//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppConfig from '@/config/app'

// 是否是H5渠道
let h5 = false

export default {
  name: 'm-question',
  data () {
    return {
      showMore: false,
      h5: h5
    }
  },
  mounted () {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
  },
  computed: {
    allQuestions () {
      if (this.h5 && !this.$store.state.h5.configuration.isNull) return AppConfig.h5Questions
      return AppConfig.questions
    },
    questions () {
      if (this.showMore) {
        return this.allQuestions
      } else {
        return this.allQuestions.slice(0, 2)
      }
    },
    moreTips () {
      if (this.showMore) {
        return '收起全部'
      } else {
        return '查看更多(' + (this.allQuestions.length - 2) + ')'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Question.vue